export default __webpack_public_path__ + "static/media/tijofi-40.b6fa0f1e.jpg";